export const saveRegisterTwoocaInput = (payload) => {
  return {
    type : 'REGISTER_TWOOCA_INPUT',
    payload: payload
  }
};
